import { CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage } from "@/shared/components";

interface Props {
  className?: string;
  action?: () => void;
}

export const SeeMore = ({ className, action }: Props) => {
  return (
    <div className={`see-more-wrapper ${className}`}>
      <CloudFlareImage
        path={CloudflareAsset.ArrowShortRight}
        onClick={action}
        className="see-more"
      />
    </div>
  );
};
